<template functional>
  <q-inner-loading :showing="props.loading">
    <q-spinner-audio :size="props.size" color="primary" />
  </q-inner-loading>
</template>

<script>
export default {
  props: {
    loading: Boolean,
    size: {
      type: [String, Number],
      default: 30
    }
  }
}
</script>
